import { render } from "./PageLoader.vue?vue&type=template&id=5794846d&ts=true"
import script from "./PageLoader.vue?vue&type=script&lang=ts"
export * from "./PageLoader.vue?vue&type=script&lang=ts"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__